var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/propose-myshop-list.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-855caf1e!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/propose-myshop-list.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ProposeMyshopList.vue
// module id = 1343
// module chunks = 1